import { render, staticRenderFns } from "./AddSuit.vue?vue&type=template&id=0bdfc78d"
import script from "./AddSuit.vue?vue&type=script&lang=js"
export * from "./AddSuit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports